import { apiGet } from './api';

export async function getUserProgressionStats(userId: string) {
  return apiGet<{
    success: boolean;
    data: {
      stats: {
        totalDocuments: number;
        completedDocuments: number;
        inProgressDocuments: number;
        notStartedDocuments: number;
        totalExperience: number;
        totalBadges: number;
        currentLevel: number;
      };
    };
  }>(`/api/v1/progression/user/${userId}/stats`);
}

export async function getUserProgressions(userId: string, limit = 50, skip = 0) {
  return apiGet<{
    success: boolean;
    data: {
      progressions: Array<{
        _id: string;
        documentCode?: string;
        documentDomain?: string;
        status?: string;
        isCompleted?: boolean;
        lastAccessedAt?: string;
      }>;
      count: number;
      total: number;
    };
  }>(`/api/v1/progression/user/${userId}?limit=${limit}&skip=${skip}`);
}
